import { render, staticRenderFns } from "./complexTodo.vue?vue&type=template&id=1ba4ef0c&scoped=true"
import script from "./complexTodo.vue?vue&type=script&lang=js"
export * from "./complexTodo.vue?vue&type=script&lang=js"
import style0 from "./complexTodo.vue?vue&type=style&index=0&id=1ba4ef0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba4ef0c",
  null
  
)

export default component.exports